import Http from '@/utils/http'
const baseUrl = '/app/student'

/**
 *练习试题列表
 * @param params
 * 
*/

export const quizInfo = params => Http.get(`${baseUrl}/activity/quiz`, { params })

/**
 *提交练习
 * @param params
 * 
*/

export const submitQuiz = params => Http.post(`${baseUrl}/activity/quiz/${params.activityId}`, params.answers)
